import apollo from '@/apollo.js'
import gql from 'graphql-tag'

export const createCaseTask = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation createCaseTask($caseTasklistId: String!, $name: String!, $position: Int!, $description: String, $assignedTo: CaseTaskAssignmentInput, $taskSchedule: CaseTaskScheduleInput ) {
            createCaseTask(caseTasklistId: $caseTasklistId, name: $name, position: $position, description: $description, assignedTo: $assignedTo, taskSchedule: $taskSchedule ) { caseTask { id name description currentStatus unresolvedFailures assignedToTeam { id } assignedToUser { id } scheduledType scheduledTime templated task { actionType } } error message lowLevelErrorMessage}
        }`),
      variables: { caseTasklistId: data.caseTasklistId, name: data.name, position: data.position, description: data.description, assignedTo: data.assignedTo, taskSchedule: data.taskSchedule }
    }
  )
  return response.data.createCaseTask
}

export const updateCaseTask = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
            mutation updateCaseTask($caseTaskId: String!, $name: String!, $position: Int!, $description: String, $assignedTo: CaseTaskAssignmentInput, $taskSchedule: CaseTaskScheduleInput ) {
                updateCaseTask(caseTaskId: $caseTaskId, name: $name, position: $position, description: $description, assignedTo: $assignedTo, taskSchedule: $taskSchedule ) { caseTask { id name description currentStatus unresolvedFailures assignedToTeam { id } assignedToUser { id } scheduledType scheduledTime templated task { actionType } } error message lowLevelErrorMessage}
            }`),
      variables: { caseTaskId: data.id, name: data.name, position: data.position, description: data.description, assignedTo: data.assignedTo, taskSchedule: data.taskSchedule }
    }
  )
  return response.data.updateCaseTask
}

export const deleteCaseTask = async (taskId) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation deleteCaseTask($caseTaskId: String!) {
        deleteCaseTask(caseTaskId: $caseTaskId) { error message lowLevelErrorMessage }
      }`),
      variables: { caseTaskId: taskId }
    }
  )
  return response.data.deleteCaseTask
}

export const executeCaseTask = async (taskId) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation executeCaseTask($caseTaskId: String!) {
        executeCaseTask(caseTaskId: $caseTaskId) { taskExecutionResult { taskId duration result startedAt stoppedAt message error } error message lowLevelErrorMessage }
      }`),
      variables: { caseTaskId: taskId }
    }
  )
  return response.data.executeCaseTask
}
